<template>
  <!-- ok保团险签署合同弹窗 -->
  <Modal
    :title="type == 1 ? '签约二维码' : '培训二维码'"
    width="500"
    v-model="visible"
    class="my-modal directional-policy"
    :mask-closable="false"
    :footer-hide="true"
  >
    <div class="title-box">
      <div v-if="type == 1" class="text">根据业务合作需求，推广团险产品需签署补充协议，请您扫码前往签署！</div>
      <div v-else-if="type == 2" class="text">根据业务合作需求，推广团险产品需要学习团险产品课程培训并考试，请您扫码学习团险课程！</div>
    </div>
    <div class="link-box" v-show="mLink">
      <div class="row">
        <vueQr :text="mLink" v-if="mLink" :size="170" :margin="0" ref="vueQr" />
      </div>
    </div>
  </Modal>
</template>
  
  <script>
import vueQr from 'vue-qr';
export default {
  props: [],
  components: {
    vueQr
  },
  data() {
    return {
      visible: false,
      loading: false,
      userInfo: {},
      mLink: '',
      type: ''
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    // 打开弹窗
    async open(data) {
      this.type = data.type; //1未签协议  2已签协议未培训考试
      if (this.type == 1) {
        let res = await this.jumpsign();
        this.mLink = res.data;
      } else {
        const orgId = this.$config.env == 1 ? '1605862923520774145' : '1626112998309031937';
        this.mLink = this.$config.h5Base + `/apps/sign/groupProductTrain?orgId=${orgId}`;
      }
      this.visible = true;
    },
    jumpsign() {
      return this.$http({
        url: '/buz/userBase/signOnlineContract',
        type: 'POST',
        data: {
          userId: this.userInfo.userid
          // redirectUrl: encodeURIComponent(location.href)
        }
      });
    }
  }
};
</script>
  
  <style lang="scss" scoped>
.directional-policy /deep/ {
  .el-dialog__header {
    padding: 0;
    height: 60px;
    line-height: 60px;
    padding-left: 30px;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    border-bottom: 1px solid #ececec;
  }
  .el-dialog__close {
    color: #666;
  }
  .ivu-modal-body {
    padding: 00px 30px 40px;
  }
  .link-box {
    text-align: center;
  }
  .title-box {
    display: flex;
    align-items: center;
    .text {
      font-size: 16px;
      color: #333;
    }
  }
}
</style>
  